import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-region",
  "use": "svg_i-region-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 17\" id=\"svg_i-region\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 10.916H0v4.053c0 1.115.9 2.027 2 2.027h4v-2.027H2v-4.053ZM2 2.81h4V.783H2c-1.1 0-2 .912-2 2.027v4.053h2V2.81ZM14 .783h-4V2.81h4v4.053h2V2.81c0-1.115-.9-2.027-2-2.027ZM14 14.97h-4v2.026h4c1.1 0 2-.912 2-2.027v-4.053h-2v4.053Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol